<template>
	<div class="upload_kuang">
		<el-upload class="upload_uploader" :action="action" :headers="headers" :show-file-list="false" :accept="accept" :before-upload="before_upload" :on-success="on_success">
			<img v-if="value" :src="value" class="upload_img">
			<i v-else class="el-icon-plus upload_icon"></i>
		</el-upload>
	</div>
</template>
<script>
export default {
	name: 'upload',
	data() {
		return {
			action:process.env.API_ROOT+'upload/uploadImage',
			headers:{
				"Authorization": "Bearer "+ sessionStorage.getItem('token'),
				'Accept': 'application/json, text/plain, */*'
			},
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		accept: {
			type: String,
			default: ''
		}
	},
	methods: {
		on_success(res){
			if (res.code==0) {
				this.$message.success('上传成功');
				this.$emit('callback',res.data);
			}else{
				this.$message.error(res.msg);
			}
			this.loading.close();
		},
		before_upload(){
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		}
	}
}
</script>
<style scoped>
.upload_kuang .upload_uploader /deep/ .el-upload{
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.upload_kuang .upload_uploader /deep/ .el-upload:hover {
	border-color: #409EFF;
}
.upload_kuang .upload_uploader /deep/ .el-upload .upload_img{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.upload_kuang .upload_uploader /deep/ .upload_icon{
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue